export default __webpack_public_path__ + "static/media/resume.654bd23e.pdf";